import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { ReactComponent as Star } from '../../images/icons/review-star.svg';
import { VALIDATION_STATE_INVALID, VALIDATION_STATE_VALID } from '../../utils/useFormValidation';

import styles from './Rating.module.scss';

const Rating = ({ className, max = 5, value = 0, interactive = false, rating, name, validationState }) => {
  const [currentRating, setCurrentRating] = useState(0);
  const [hasSelected, setHasSelected] = useState(false);

  const rate = (number) => {
    setCurrentRating(number);
    setHasSelected(true);
    rating(number);
  };

  const onCancelRate = () => {
    if (!hasSelected) {
      setCurrentRating(value);
    }
  };

  const willRate = (number) => {
    setCurrentRating(number);
  };

  useEffect(() => {
    setCurrentRating(value);
  }, [value]);

  const valueToCompare = interactive ? currentRating : value;

  return (
    <div
      className={classNames(className, styles.rating, {
        [styles.interactive]: interactive,
        [styles.valid]: validationState === VALIDATION_STATE_VALID,
        [styles.invalid]: validationState === VALIDATION_STATE_INVALID,
      })}
      onMouseLeave={() => onCancelRate()}
    >
      {[...Array(max).keys()].map((currentVal) => {
        const isHighlighted = currentVal < valueToCompare ? 'isHighlighted' : 'default';
        return (
          <span
            key={currentVal}
            onClick={() => (interactive ? rate(currentVal + 1) : null)}
            onMouseEnter={() => (interactive ? willRate(currentVal + 1) : null)}
            className={styles[isHighlighted]}
          >
            <Star />
          </span>
        );
      })}
      {!!interactive && (
        <input
          type="number"
          className={styles.ratingInputNumber}
          required
          name={name}
          value={currentRating || 0}
          min={1}
          max={5}
        />
      )}
    </div>
  );
};

Rating.displayName = 'Rating';
export default Rating;
